import React from "react";
import styles from "./FeedbackNavigationFooter.module.scss";

import { LinearProgress, IconButton } from "@material-ui/core";

import { ArrowBackIosSharp, ArrowForwardIosSharp } from "@material-ui/icons";
import clsx from "clsx";

const FeedbackNavigationFooter = ({
  currentStepIndex,
  currentProgressPercentage,
  isFirstStep,
  isLastStep,
  next,
  goForwardTwoSteps,
  goBackTwoSteps,
  setValidationError,
  setConditionalInputError,
  validateMandatoryInput,
  validateConditionalInput,
  back,
  formData,
}) => {
  const navigateBack = async () => {
    setConditionalInputError("");
    setValidationError("");
    const conditionalResult = await validateConditionalInput(
      formData,
      currentStepIndex - 2
    );

    if (conditionalResult?.error) {
      return goBackTwoSteps();
    }

    setConditionalInputError("");
    return back();
  };
  const navigateNextStep = async () => {
    setValidationError("");
    setConditionalInputError("");
    const mandatoryResult = await validateMandatoryInput(
      formData,
      currentStepIndex
    );
    if (mandatoryResult?.error) {
      return;
    }
    const conditionalResult = await validateConditionalInput(
      formData,
      currentStepIndex
    );

    if (conditionalResult?.error) {
      return goForwardTwoSteps();
    }

    setConditionalInputError("");
    return next();
  };
  return (
    <div className={styles.container}>
      {!isFirstStep && (
        <IconButton
          onClick={navigateBack}
          className={clsx(
            styles.alignVerticalAligment,
            styles.iconColor,
            styles.marginRight
          )}
          disabled={
            currentStepIndex && parseInt(currentStepIndex) === 1 ? true : false
          }
          data={currentStepIndex}
        >
          <ArrowBackIosSharp />
        </IconButton>
      )}
      <div className={styles.alignVerticalAligment}>
        <LinearProgress
          style={{ width: "460px", borderRadius: "0.5rem" }}
          color="secondary"
          variant="determinate"
          size="md"
          value={currentProgressPercentage}
          thickness={24}
        />
      </div>
      <p className={styles.progressText}>{currentProgressPercentage} %</p>

      {!isLastStep && (
        <IconButton
          onClick={navigateNextStep}
          className={clsx(
            styles.alignVerticalAligment,
            styles.iconColor,
            styles.marginLeft
          )}
        >
          <ArrowForwardIosSharp />
        </IconButton>
      )}
    </div>
  );
};

export default FeedbackNavigationFooter;
